"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeMapParse = void 0;
/**
 * Template method for parsing entities from array of inputs.
 * The method tolerates any error and prints up to certain number of errors in logs.
 *
 * Limited error logging to a given maximum to prevent excessive log output.
 * This safeguard helps avoid flooding logs with potentially repetitive error messages.
 */
const safeMapParse = (logger, input, parser, printedErrorCount = 3) => {
    let parsingErrors = 0;
    const output = input
        .map(i => {
        try {
            return parser(i);
        }
        catch (error) {
            parsingErrors++;
            if (printedErrorCount-- > 0) {
                logger.debug(`Error while parsing.`, error);
            }
        }
    })
        .filter((a) => a !== undefined);
    return { output, parsingErrors };
};
exports.safeMapParse = safeMapParse;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2FmZS1tYXAtcGFyc2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvc2FmZS1tYXAtcGFyc2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUE7Ozs7OztHQU1HO0FBQ0ksTUFBTSxZQUFZLEdBQUcsQ0FDMUIsTUFBYyxFQUNkLEtBQXVCLEVBQ3ZCLE1BQTRCLEVBQzVCLG9CQUE0QixDQUFDLEVBQ2dCLEVBQUU7SUFDL0MsSUFBSSxhQUFhLEdBQUcsQ0FBQyxDQUFBO0lBQ3JCLE1BQU0sTUFBTSxHQUFHLEtBQUs7U0FDakIsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFO1FBQ1AsSUFBSSxDQUFDO1lBQ0gsT0FBTyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDbEIsQ0FBQztRQUFDLE9BQU8sS0FBSyxFQUFFLENBQUM7WUFDZixhQUFhLEVBQUUsQ0FBQTtZQUNmLElBQUksaUJBQWlCLEVBQUUsR0FBRyxDQUFDLEVBQUUsQ0FBQztnQkFDNUIsTUFBTSxDQUFDLEtBQUssQ0FBQyxzQkFBc0IsRUFBRSxLQUFLLENBQUMsQ0FBQTtZQUM3QyxDQUFDO1FBQ0gsQ0FBQztJQUNILENBQUMsQ0FBQztTQUNELE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBZSxFQUFFLENBQUMsQ0FBQyxLQUFLLFNBQVMsQ0FBQyxDQUFBO0lBRTlDLE9BQU8sRUFBRSxNQUFNLEVBQUUsYUFBYSxFQUFFLENBQUE7QUFDbEMsQ0FBQyxDQUFBO0FBckJZLFFBQUEsWUFBWSxnQkFxQnhCIn0=